"use client";

import { useEffect, useState } from "react";
import { useTranslations } from "use-intl";

import SignInForm from "@/components/sign-in-form";
import SignUpForm from "@/components/sign-up-form";
import { cn } from "@/lib/utils";

interface LoginContentProps {
  initialMode?: "signin" | "signup";
  redirectAfterLogin?: string;
}

export function LoginContent({ initialMode = "signin", redirectAfterLogin }: LoginContentProps) {
  const t = useTranslations("globals.auth");
  const [mode, setMode] = useState<"signin" | "signup">(initialMode);

  useEffect(() => {
    setMode(initialMode);
  }, [initialMode]);

  useEffect(() => {}, [mode]);

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-2 rounded-lg border border-border bg-muted/40 p-1">
        {(["signup", "signin"] as const).map((item) => (
          <button
            key={item}
            type="button"
            onClick={() => setMode(item)}
            className={cn(
              "h-11 rounded-md text-sm font-medium transition-colors sm:h-9",
              mode === item
                ? "bg-background text-foreground shadow-sm"
                : "text-muted-foreground hover:text-foreground",
            )}
          >
            {item === "signup" ? t("signUp") : t("signIn")}
          </button>
        ))}
      </div>

      {mode === "signin" ? (
        <SignInForm redirectAfterLogin={redirectAfterLogin} />
      ) : (
        <SignUpForm redirectAfterLogin={redirectAfterLogin} />
      )}
    </div>
  );
}
